export default {
	title: 'Rischi / Aperture',
	risks: 'Rischi',
	opportunities: 'Aperture',
	url: 'rischi',
	subtitle: '',
	all_categories: 'Filtro categorie',
	all_impacts: 'Filtro impatto',
	all_likelihoods: 'Filtro probabilità',
	all_stakeholders: 'Filtro parti interessate',
	all_stakes: 'Filtro interessi',
	no_stakeholder: 'Nessuna parte interessata',
	tabs: {
		filters: {
			title: 'Filtri vista',

			displayed_columns: 'Colonne visualizzate',
			visualization_options: 'Opzioni visualizzazione'
		},
		options: {
			title: 'Mostra',
			are_links_visible: 'Mostra tutti i link',
			show_description: 'Mostra descrizione',
			chart_visible_stakes: 'Mostra interessi',
			chart_visible_stakeholders: 'Mostra parti interessate',
			chart_visible_risks: 'Mostra rischi',
			chart_visible_opportunities: 'Mostra aperture'
		},
		general: {
			title: 'Generale'
		},
		stakeholders: {
			title: 'Parti interessate'
		},
		export: {
			title: 'Esporta'
		},
		comments: {
			title: 'Cronologia'
		}
	},
	visualization_tab: 'Visualizzazione',
	onboarding: {
		risks: {
			title: 'Revisione dei rischi',
			description:
				'Ecco i rischi che gravano sui tuoi interessi. Valuta la loro probabilità e il loro impatto e correggi quelli che ti sembrano mal calibrati.'
		},
		opportunities: {
			title: 'Revisione delle aperture',
			description:
				'A differenza dei rischi, le aperture sono dinamiche che possono rafforzare i tuoi interessi. Mantieni quelle azionabili, scarta il resto.'
		}
	}
};
